import MapViewTab from './mapViewTab'
export default MapViewTab
